"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProRatedAmount = exports.updateSavedAndProRatedAmount = exports.splitComboItems = exports.adjustProRateValue = exports.getAdvancedDiscountDetailByOrderItems = exports.processLineAndVoidedItems = exports.processOrderItems = exports.reduceProcessedItemTotals = exports.setComboItemAdjustment = exports.getTotalProductOriginalPrice = void 0;
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("./computePrice");
const computeOrderItemTotals_1 = require("./computeOrderItemTotals");
const utils_1 = require("./utils");
const uuid_1 = require("uuid");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
/**
 *
 * @param item which hold combo items
 * @param comboItems
 * @returns total original price for the combo products
 */
const getTotalProductOriginalPrice = (item, comboItems) => {
    return comboItems.reduce((total, comboItem) => (0, utils_1.sumDecimals)([
        total,
        item.quantity *
            (comboItem.quantity || 1) *
            ((comboItem.productOriginalPrice || 0) +
                getModifiersTotal(comboItem.modifiers)),
    ]), 0);
};
exports.getTotalProductOriginalPrice = getTotalProductOriginalPrice;
/**
 *
 * @param item which holds the combo
 * @param totalProductOriginalPrice sum of original combo products
 */
const setComboItemAdjustment = (item, totalProductOriginalPrice, comboItem) => {
    var _a, _b;
    comboItem.adjustments = [];
    const discountAmount = item.discountAmount || 0;
    const surchargeAmount = item.surchargeAmount || 0;
    const savedAmount = (0, computeOrderItemTotals_1.getItemSavedAmount)(item);
    if (savedAmount > 0) {
        const savedValuePercentage = (savedAmount / totalProductOriginalPrice) * 100;
        // adjustment to push for saved value
        const savedAdjustmentToPush = {
            id: domain_1.COMBO_DISCOUNT_ID,
            name: 'Combo Discounts',
            amount: -(0, utils_1.limitDecimalCount)(savedValuePercentage),
            adjustmentUnit: domain_1.AdjustmentUnit.PERCENTAGE,
            adjustmentType: domain_1.AdjustmentType.DISCOUNT,
            allowOnPaymentType: false,
        };
        const appliedItemAdjustment = (0, lodash_clonedeep_1.default)((_a = item.adjustments) === null || _a === void 0 ? void 0 : _a.find(a => [domain_1.AdjustmentType.DISCOUNT, domain_1.AdjustmentType.SURCHARGE].includes(a.adjustmentType)));
        if (appliedItemAdjustment) {
            const isDiscount = appliedItemAdjustment.adjustmentType === domain_1.AdjustmentType.DISCOUNT;
            const adjustmentAmount = isDiscount ? discountAmount : surchargeAmount;
            const appliedAdjustmentPercentage = (adjustmentAmount / totalProductOriginalPrice) * 100;
            const percentage = (0, utils_1.limitDecimalCount)(appliedAdjustmentPercentage);
            appliedItemAdjustment.amount = isDiscount ? -percentage : percentage;
            appliedItemAdjustment.adjustmentUnit = domain_1.AdjustmentUnit.PERCENTAGE;
            comboItem.adjustments.push(appliedItemAdjustment, savedAdjustmentToPush);
        }
        else {
            comboItem.adjustments.push(savedAdjustmentToPush);
        }
    }
    else {
        comboItem.adjustments = (_b = item.adjustments) !== null && _b !== void 0 ? _b : [];
    }
};
exports.setComboItemAdjustment = setComboItemAdjustment;
/**
 * Reduce processed item totals.
 * @param processedItems ProcessedOrderItem[]
 */
function reduceProcessedItemTotals(processedItems) {
    return processedItems
        .filter(i => { var _a; return !((_a = i.comboItems) === null || _a === void 0 ? void 0 : _a.length); })
        .reduce((prev, item) => {
        return {
            costPrice: (0, utils_1.sumDecimals)([
                prev.costPrice,
                (0, utils_1.limitDecimalCount)((0, computePrice_1.computeLineCost)(item)),
            ]),
            grossPrice: (0, utils_1.sumDecimals)([
                prev.grossPrice,
                (0, utils_1.limitDecimalCount)(item.grossPrice),
            ]),
            itemsCount: item.belongsTo
                ? prev.itemsCount
                : prev.itemsCount + item.quantity,
            modifiersCount: !item.belongsTo
                ? prev.modifiersCount
                : prev.modifiersCount + item.quantity,
            netAmount: (0, utils_1.sumDecimals)([
                prev.netAmount,
                (0, utils_1.limitDecimalCount)(item.netAmount),
            ]),
            totalDiscount: (0, utils_1.sumDecimals)([
                prev.totalDiscount,
                (0, utils_1.limitDecimalCount)(item.totalDiscount),
            ]),
            totalSurcharge: (0, utils_1.sumDecimals)([
                prev.totalSurcharge,
                (0, utils_1.limitDecimalCount)(item.totalSurcharge),
            ]),
            otherCharges: (0, utils_1.sumDecimals)([
                prev.otherCharges,
                (0, utils_1.limitDecimalCount)(item.otherCharges || 0),
            ]),
        };
    }, {
        grossPrice: 0,
        netAmount: 0,
        costPrice: 0,
        itemsCount: 0,
        modifiersCount: 0,
        totalDiscount: 0,
        totalSurcharge: 0,
        otherCharges: 0,
    });
}
exports.reduceProcessedItemTotals = reduceProcessedItemTotals;
const processModifiers = ({ modifiers, item, order, processedItems, comboMetadata, }) => {
    modifiers === null || modifiers === void 0 ? void 0 : modifiers.forEach(modifier => {
        const modifierItem = {
            id: item.id,
            unitPrice: modifier.unitPrice,
            // TODO: Add cost price for modifier (when we support it).
            costPrice: 0,
            // modifier actual quantity is item.quantity * modifier.quantity
            quantity: modifier.quantity * item.quantity,
            status: item.status,
            product: {
                id: modifier.id,
                name: modifier.name,
                productType: item.product.productType,
            },
            //what if modifier is not tax inclusive(product)#test item with product modifier
            taxInclusive: item.taxInclusive,
            discountAmount: 0,
            discounts: item.discounts,
            adjustments: item === null || item === void 0 ? void 0 : item.adjustments,
            taxes: modifier.taxes,
            reason: item.reason,
            // modifier group information, used for modifier per group reports
            modifierGroup: modifier.modifierGroup,
        };
        processedItems.push({
            orderId: order.id,
            orderItemId: item.id,
            belongsTo: item.product.id,
            ...((comboMetadata === null || comboMetadata === void 0 ? void 0 : comboMetadata.comboId) && comboMetadata),
            ...modifierItem,
            ...(0, computeOrderItemTotals_1.computeOrderItemTotals)(modifierItem, order.subTotal, order.adjustments),
        });
    });
};
/**
 * Generate processed order items.
 * @param order Order
 */
function processOrderItems(orderItems, order) {
    const processedItems = [];
    (0, utils_1.clone)(orderItems).forEach(item => {
        // Converting item's flat discounts to percentage (if any).
        // This will help use in calculations.
        // as are splitting order item and its modifiers.
        var _a, _b, _c;
        const originalItemAdjustments = (0, lodash_clonedeep_1.default)((item === null || item === void 0 ? void 0 : item.adjustments) || []);
        const adjustmentsInPercentage = originalItemAdjustments === null || originalItemAdjustments === void 0 ? void 0 : originalItemAdjustments.map(adjustment => {
            // distribute discount value based on adjustment applied item quantity
            const revisedQuantity = Math.min(item.quantity, adjustment.itemQuantity || item.quantity);
            // Calculate price using revised quantity
            const itemPrice = (0, computePrice_1.computeLineTotal)({
                ...item,
                quantity: revisedQuantity,
            });
            const adjInPercentage = (0, computePrice_1.flatToPercentageForAdjustment)(adjustment, itemPrice);
            return (0, computePrice_1.limitAdjustmentToMaxAmount)(adjInPercentage, itemPrice);
        });
        item.adjustments = adjustmentsInPercentage;
        const modifiers = (0, utils_1.clone)(item.modifiers);
        delete item.modifiers;
        const comboItems = (0, utils_1.clone)(item.comboItems || []);
        let totalProductOriginalPrice = 0;
        if (((_a = item.variant) === null || _a === void 0 ? void 0 : _a.category) && !((_b = item.product) === null || _b === void 0 ? void 0 : _b.category)) {
            // if an item is variant product, set category with variant's category
            // This is to counter the fact that category is only assigned to parent variants and not variant products
            item.product.category = item.variant.category;
        }
        let orderItem = item;
        if (comboItems.length) {
            orderItem = {
                ...item,
                savedAmount: item.savedAmount,
                modifiers: [],
                adjustments: item.adjustments,
                discountAmount: 0,
                surchargeAmount: 0,
            };
            totalProductOriginalPrice = (0, exports.getTotalProductOriginalPrice)(item, comboItems);
        }
        processedItems.push({
            orderId: order.id,
            orderItemId: item.id,
            belongsTo: '',
            ...orderItem,
            ...(0, computeOrderItemTotals_1.computeOrderItemTotals)(orderItem, order === null || order === void 0 ? void 0 : order.subTotal, (_c = order === null || order === void 0 ? void 0 : order.adjustments) !== null && _c !== void 0 ? _c : []),
        });
        (comboItems === null || comboItems === void 0 ? void 0 : comboItems.length) &&
            comboItems.forEach(comboItem => {
                var _a, _b, _c, _d, _e;
                const savedAmount = (0, computeOrderItemTotals_1.getItemSavedAmount)(item);
                (0, exports.setComboItemAdjustment)(item, totalProductOriginalPrice, comboItem);
                const comboId = item.product.id, comboName = item.product.name;
                const comboItemModifiers = (_a = comboItem.modifiers) !== null && _a !== void 0 ? _a : [];
                delete comboItem.modifiers;
                const processedItem = {
                    ...comboItem,
                    product: {
                        ...comboItem.product,
                        category: ((_c = (_b = comboItem.variant) === null || _b === void 0 ? void 0 : _b.category) === null || _c === void 0 ? void 0 : _c.id)
                            ? comboItem.variant.category
                            : comboItem.product.category,
                    },
                    costPrice: 0,
                    ...(savedAmount > 0
                        ? {
                            unitPrice: comboItem.productOriginalPrice,
                            quantity: item.quantity * comboItem.quantity,
                        }
                        : {
                            unitPrice: (0, utils_1.sumDecimals)([
                                comboItem.proRatedAmount,
                                -comboItem.quantity * getModifiersTotal(comboItemModifiers),
                            ]),
                            quantity: item.quantity,
                        }),
                    status: item.status,
                    taxInclusive: item.taxInclusive,
                    discountAmount: 0,
                    surchargeAmount: 0,
                    adjustments: (_d = comboItem === null || comboItem === void 0 ? void 0 : comboItem.adjustments) !== null && _d !== void 0 ? _d : [],
                    taxes: item.taxes,
                    reason: item.reason,
                };
                processedItems.push({
                    orderId: order.id,
                    orderItemId: comboItem.id,
                    belongsTo: '',
                    parentComboItemId: item.id,
                    comboId,
                    comboName,
                    taxes: comboItem.taxes,
                    unitPriceInCombo: comboItem.unitPrice,
                    ...processedItem,
                    ...(0, computeOrderItemTotals_1.computeOrderItemTotals)(processedItem, order.subTotal, order.adjustments),
                });
                (comboItemModifiers === null || comboItemModifiers === void 0 ? void 0 : comboItemModifiers.length) &&
                    processModifiers({
                        modifiers: comboItemModifiers.map(m => {
                            var _a;
                            return ({
                                ...m,
                                taxes: (_a = item.taxes) !== null && _a !== void 0 ? _a : [],
                            });
                        }),
                        item: {
                            ...item,
                            ...comboItem,
                            adjustments: (_e = comboItem === null || comboItem === void 0 ? void 0 : comboItem.adjustments) !== null && _e !== void 0 ? _e : [],
                            quantity: (item.quantity || 1) * (comboItem.quantity || 1),
                        },
                        order,
                        processedItems,
                        comboMetadata: {
                            comboId,
                            comboName,
                        },
                    });
            });
        (modifiers === null || modifiers === void 0 ? void 0 : modifiers.length) &&
            processModifiers({ modifiers, item, order, processedItems });
    });
    return processedItems;
}
exports.processOrderItems = processOrderItems;
/**
 * Processes line and voided item's separated totals and returns them.
 * @param order Order
 */
function processLineAndVoidedItems(order, isExcludeCombo = false) {
    const lineItems = [];
    const voidedItems = [];
    let processedItems = processOrderItems(order.orderItems || [], order);
    let comboItems = [];
    /*
      We don't want to store combos to data-lake as we already splitted combo products into items
      We want combos details for shift summary to show the product type sales for combo reporting group
    */
    if (isExcludeCombo) {
        comboItems = processedItems.filter(item => { var _a; return (_a = item.comboItems) === null || _a === void 0 ? void 0 : _a.length; });
        processedItems = processedItems.filter(item => { var _a; return !((_a = item.comboItems) === null || _a === void 0 ? void 0 : _a.length); });
    }
    processedItems.forEach(item => {
        if (item.status === domain_1.OrderItemStatus.VOID) {
            voidedItems.push(item);
        }
        else if (item.status !== domain_1.OrderItemStatus.CANCELLED &&
            item.status !== domain_1.OrderItemStatus.TRANSFERRED) {
            lineItems.push(item);
        }
    });
    return {
        processedItems,
        lineItems,
        voidedItems,
        lineItemsTotals: reduceProcessedItemTotals(lineItems),
        voidedItemsTotals: reduceProcessedItemTotals(voidedItems),
        comboItems,
    };
}
exports.processLineAndVoidedItems = processLineAndVoidedItems;
/**
 *
 * @param adjustmentByOrderItem contains map for orderItem adjustment
 * @returns common adjustments for orderItemIds
 */
const getAdvancedDiscountDetailByOrderItems = (adjustmentByOrderItem) => {
    const groupAdjustmentByItemIds = [];
    const adjustmentToRemoveFromOrderItemIds = [];
    const splittedOrderItems = [];
    const orderItemKeys = Object.keys(adjustmentByOrderItem);
    orderItemKeys.forEach(orderItemId => {
        const splitQty = adjustmentByOrderItem[orderItemId].splitQty;
        if (splitQty) {
            splittedOrderItems.push({
                quantity: splitQty,
                orderItemId,
                splitOrderItemId: (0, uuid_1.v4)(),
            });
            return;
        }
        const adjustment = adjustmentByOrderItem[orderItemId].adjustment;
        if (!adjustment) {
            adjustmentToRemoveFromOrderItemIds.push(orderItemId);
            return;
        }
        const commonAdjustmentByItemId = groupAdjustmentByItemIds.find(item => {
            var _a;
            return ((_a = item === null || item === void 0 ? void 0 : item.adjustment) === null || _a === void 0 ? void 0 : _a.id) === adjustment.id &&
                (item === null || item === void 0 ? void 0 : item.adjustment.quantity) === adjustment.quantity;
        });
        if (commonAdjustmentByItemId)
            commonAdjustmentByItemId.orderItemIds = [
                ...commonAdjustmentByItemId.orderItemIds,
                orderItemId,
            ];
        else
            groupAdjustmentByItemIds.push({
                orderItemIds: [orderItemId],
                adjustment,
            });
    });
    return {
        groupAdjustmentByItemIds,
        adjustmentToRemoveFromOrderItemIds,
        splittedOrderItems,
    };
};
exports.getAdvancedDiscountDetailByOrderItems = getAdvancedDiscountDetailByOrderItems;
/*
  We're adjusting the pro rate value so that we don't need to hold the large decimal number
  which can precision loss issue
*/
const adjustProRateValue = (item) => {
    const lineTotal = (0, computePrice_1.computeLineTotal)({ ...item, quantity: 1 });
    const comboItems = item.comboItems;
    let total = 0;
    item.comboItems = comboItems.map((product, index) => {
        total += product.proRatedAmount;
        if (index + 1 === comboItems.length) {
            const extraValue = (0, utils_1.sumDecimals)([total, -lineTotal]);
            product.proRatedAmount = (0, utils_1.limitDecimalCount)((0, utils_1.sumDecimals)([product.proRatedAmount, -extraValue]));
            return product;
        }
        return product;
    });
};
exports.adjustProRateValue = adjustProRateValue;
const getModifiersTotal = (modifiers) => {
    if (modifiers === null || modifiers === void 0 ? void 0 : modifiers.length) {
        return modifiers.reduce((total, m) => {
            const modifierTotal = (m.unitPrice || 0) * (m.quantity || 1);
            return total + modifierTotal;
        }, 0);
    }
    else
        return 0;
};
const getProductOriginalPrice = ({ quantity, productOriginalPrice, modifiers, }) => {
    return quantity * (productOriginalPrice + getModifiersTotal(modifiers));
};
const splitComboItems = (orderItems) => {
    const filteredOrderItems = (0, lodash_clonedeep_1.default)((orderItems || []).filter(i => { var _a; return !((_a = i.parentCombo) === null || _a === void 0 ? void 0 : _a.id); }));
    const itemsToPush = [];
    // [START] Finding parent combos
    const parentCombos = filteredOrderItems.filter(i => { var _a; return (_a = i.comboItems) === null || _a === void 0 ? void 0 : _a.length; });
    const comboItems = parentCombos
        .map(i => i.comboItems || [])
        .flat();
    // [END] Finding parent combos
    // [START] Creating/Updating course item for individual item from combo
    comboItems === null || comboItems === void 0 ? void 0 : comboItems.forEach(comboItem => {
        const parentCombo = parentCombos.find(i => i.comboItems.find(item => item.id === comboItem.id));
        const combo = { id: parentCombo.id, name: parentCombo.product.name };
        itemsToPush.push({
            ...comboItem,
            parentCombo: combo,
            quantity: (parentCombo.quantity || 1) * (comboItem.quantity || 1),
            reason: parentCombo.reason,
            notes: parentCombo.notes,
            itemFired: comboItem.itemFired,
            ...(parentCombo.createdAt && { createdAt: parentCombo.createdAt - 1 }),
        });
    });
    // [END] Creating course item for individual item from combo
    filteredOrderItems.push(...itemsToPush);
    return (0, lodash_clonedeep_1.default)(filteredOrderItems);
};
exports.splitComboItems = splitComboItems;
const updateSavedAndProRatedAmount = (comboProductPriceMap, itemToUpdate) => {
    const originalProductsTotal = Object.values(comboProductPriceMap).reduce((sum, e) => sum +
        getProductOriginalPrice({
            quantity: e.quantity,
            productOriginalPrice: e.productOriginalPrice,
            modifiers: e.modifiers,
        }), 0);
    const comboMealPrice = (0, computePrice_1.computeLineTotal)({ ...itemToUpdate, quantity: 1 });
    const savedAmount = (0, utils_1.limitDecimalCount)((0, utils_1.sumDecimals)([originalProductsTotal, -comboMealPrice]));
    itemToUpdate.comboItems = itemToUpdate.comboItems.map(product => ({
        ...product,
        proRatedAmount: (0, exports.getProRatedAmount)(savedAmount, originalProductsTotal, getProductOriginalPrice(comboProductPriceMap[product.product.id])),
    }));
    itemToUpdate.savedAmount = savedAmount;
};
exports.updateSavedAndProRatedAmount = updateSavedAndProRatedAmount;
/**
 *
 * @param savedAmount savedAmount for comboItem
 * @param originalProductsTotal total of original products which is present in combo
 * @param originalProductPrice  original product price which is present in combo
 * @returns
 */
const getProRatedAmount = (savedAmount, originalProductsTotal, originalProductPrice) => {
    if (savedAmount === 0) {
        return (0, utils_1.limitDecimalCount)(originalProductPrice);
    }
    /*
    If savedAmount is positive means we're selling combo in lesser value than the actual product price
      if savedAmount is positive then we should subtract pro rate value from original product price &
      if savedAmount is negative then we should add pro rate value from original product price
    */
    const sign = savedAmount > 0 ? '-' : '+';
    const productOp = {
        '+': function (a, b) {
            return a + b;
        },
        '-': function (a, b) {
            return a - b;
        },
    };
    const discountPercentage = Math.abs((0, utils_1.sumDecimals)([savedAmount / originalProductsTotal]));
    const productPriceToSubtractOrAdd = originalProductPrice * discountPercentage;
    return (0, utils_1.limitDecimalCount)(productOp[sign](originalProductPrice, productPriceToSubtractOrAdd));
};
exports.getProRatedAmount = getProRatedAmount;
//# sourceMappingURL=orderItemHelper.js.map